<template>
    <div>
        <component :is="'style'">{{ styles }}</component>
        <link href="https://fonts.gstatic.com" rel="preconnect">
        <link v-if="googleFontLink" :href="'https://fonts.googleapis.com/css2'+googleFontLink+'&display=swap'" rel="stylesheet">
    </div>
</template>

<script>
import {mapState} from 'pinia';
import { useBrandingStore } from '../../state/branding';
import {fonts} from '../../helpers';

export default {
    data: function () {
        return {
            activeDisplayFont: 'system-ui, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
            activeTextFont: 'system-ui, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
        };
    },
    computed: {
        ...mapState(useBrandingStore, [
            'settings',
            'brandHSLA',
            'brandHex',
            'brandContrastHEX',
            'textContrastHEX',
            'brand10HSLA',
            'brand30HSLA',
            'textHSLA',
            'textLightHex',
            'text50HSLA',
            'text70HSLA',
            'text80HSLA',
            'displayFont',
            'textFont',
            'complementBrandHex',
        ]),
        styles() {
            return `
                .site__rounded--small {
                    border-radius: ${Math.min(this.settings.rounding, 0.25) * 50}px;
                }
                .site__rounded--small-top {
                    border-radius: ${Math.min(this.settings.rounding, 0.25) * 50}px ${Math.min(this.settings.rounding, 0.25) * 50}px 0 0;
                }
                .site__rounded--medium {
                    border-radius: ${this.settings.rounding * 100}px;
                }
                .site__rounded--medium-top {
                    border-radius: ${this.settings.rounding * 100}px ${this.settings.rounding * 100}px 0 0;
                }
                .site__rounded--medium-bottom {
                    border-radius: 0 0 ${this.settings.rounding * 100}px ${this.settings.rounding * 100}px;
                }
                .site__rounded--medium-left {
                    border-radius: ${this.settings.rounding * 100}px 0 0 ${this.settings.rounding * 100}px;
                }
                .site__rounded--medium-right {
                    border-radius: 0 ${this.settings.rounding * 100}px ${this.settings.rounding * 100}px 0;
                }
                .site__rounded--large {
                    border-radius: ${this.settings.rounding > 0.04 ? '999' : this.settings.rounding * 100}px;
                }
                .site__padding--medium {
                    padding: ${this.settings.padding * 100}px;
                }
                .site__bg--brand {
                    background-color: ${this.brandHSLA};
                }
                .site__bg--brand-10 {
                    background-color: ${this.brand10HSLA};
                }
                .site__bg--brand-30 {
                    background-color: ${this.brand30HSLA};
                }
                .site__color--brand-contrast {
                    color: ${this.brandContrastHEX}
                }
                .site__color--text-contrast {
                    color: ${this.textContrastHEX}
                }
                .site__color--brand {
                    color: ${this.brandHSLA};
                }
                .site__bg--text {
                    background-color: ${this.textHSLA};
                }
                .site__hover__bg--text:hover {
                    background-color: ${this.textHSLA};
                }
                .site__bg--text-80 {
                    background-color: ${this.text80HSLA};
                }
                .site__fill--brand {
                    fill: ${this.brandHex};
                }
                .site__fill--brand-contrast {
                    fill: ${this.brandContrastHEX};
                }
                .site__color--text {
                    color: ${this.textHSLA};
                }
                ::placeholder {
                    color: ${this.textLightHex};
                }
                .site__color--text-light {
                    color: ${this.textLightHex};
                }
                .site__color--text-50 {
                    color: ${this.text50HSLA};
                }
                .site__color--text-70 {
                    color: ${this.text70HSLA};
                }
                .site__border--brand {
                    border-color: ${this.brandHex};
                }
                .site__focus--brand:focus,
                .site__focus--brand:focus ~ .input-icon,
                .site__focus--brand:focus ~ label,
                .site__focus--brand:focus ~ span.checkmark {
                    border-color: ${this.brandHSLA};
                }
                .site__focus--outline-brand:focus,
                .site__focus--outline-brand:focus ~ .file-upload,
                .site__focus--outline-brand:focus ~ label,
                .site__focus--outline-brand:focus ~ span.checkmark {
                    box-shadow: 0 0 0 0.2rem ${this.brand30HSLA};
                }
                .site__select--brand *::selection {
                    background-color: ${this.brandHSLA};
                }
                .site__selection--complement-brand *::selection {
                    color: ${this.complementBrandHex};
                },
                .site__border--text {
                    border-color: ${this.textHSLA};
                }
                .site__border--text-light {
                    border-color: ${this.textLightHex};
                }
                .site__font--display {
                    font-family: ${this.displayFontFamily};
                }
                .site__font--text {
                    font-family: ${this.textFontFamily};
                }


                .cc-banner.cc-bottom {
                    background-color: ${this.brandHSLA};
                    color: ${this.brandContrastHEX};
                }
                .cc-banner.cc-bottom .cc-link {
                    color: ${this.brandContrastHEX};
                }
                .cc-btn.cc-dismiss {
                    color: ${this.brandContrastHEX};
                    background: transparent;
                    border: 2px solid ${this.brandContrastHEX};
                    transition: ease 150ms;
                }
                .cc-btn.cc-dismiss:hover {
                    background: ${this.brandContrastHEX};
                    color: ${this.brandHSLA};
                }
                .bg-white-ie11{
                    background-color: #fff;
                }
                .bg-black-ie11{
                    background-color: #000;
                }
                .wysiwyg-content > table {
                    border-collapse: collapse;
                    width: 100%;
                }
                .wysiwyg-content > table td,
                .wysiwyg-content > table th {
                    position: relative;
                    box-sizing: border-box;
                    vertical-align: top;
                    border: 1px solid ${this.brandHex};
                    padding: .6rem .8rem;
                }
                .wysiwyg-content > table td > *,
                .wysiwyg-content > table th > * {
                    margin-bottom: 0;
                }
                .wysiwyg-content > table th {
                    font-weight: 600;
                    text-align: left;
                }
                .wysiwyg-content > table th {
                    font-weight: semibold;
                    text-align: left;
                    background: ${this.brandHSLA};
                    color: ${this.brandContrastHEX};
                }
            `;
        },
        displayFontFamily() {
            let font = this.settings.display_font;
            return fonts.isSystemFont(font) ? fonts.systemFontStack(font) : font + ', sans-serif';
        },
        textFontFamily() {
            let font = this.settings.text_font;
            return fonts.isSystemFont(font) ? fonts.systemFontStack(font) : font + ', sans-serif';
        },
        googleFontLink() {
            let displayFont = this.settings.display_font;
            let textFont = this.settings.text_font;
            let family = '';

            if (!fonts.isSystemFont(displayFont)) {
                family = '?family=' + displayFont + ':wght@400;700';
            }
            if (!fonts.isSystemFont(textFont) && displayFont !== textFont) {
                if (family.length) {
                    family += '&';
                } else {
                    family = '?';
                }

                family += 'family=' + textFont + ':wght@400;700';
            }

            return family;
        },
    },
};
</script>
